export default __webpack_public_path__ + "static/media/bsparkles.57937088.jpg";